var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback, useMemo } from "react";
import { Button as BaseButton, useTheme } from "native-base";
import Icon from "../icons/Icon";
import useResponsive from "../util/useResponsive";
const Button = forwardRef((_a, ref) => {
    var { variant = "primary", size = "md", isDisabled = false, onPress, children, leftIconName, rightIconName, forceIcon, transparent = false } = _a, rest = __rest(_a, ["variant", "size", "isDisabled", "onPress", "children", "leftIconName", "rightIconName", "forceIcon", "transparent"]);
    const { colors } = useTheme();
    const { isSmallScreen } = useResponsive();
    const iconSizes = useMemo(() => ({
        xs: 16,
        sm: 18,
        md: 20,
        lg: 20,
        xl: 20,
        "2xl": 22,
    }), []);
    const iconVariants = useMemo(() => ({
        primary: colors.white,
        destructive: colors.white,
        gray: colors.gray[800],
        outlined: isDisabled ? colors.gray[300] : colors.gray[800],
        ghost: colors.gray[900],
        ghostGreen: colors.green[500],
        link: colors.green[600],
        ghostLink: colors.gray[800],
    }), [colors, isDisabled]);
    const renderIcon = useCallback((iconName) => (_jsx(Icon, { name: iconName, fill: iconVariants[variant], size: iconSizes[size] })), [iconVariants, iconSizes, size, variant]);
    return (_jsx(BaseButton, Object.assign({ accessibilityRole: "button", leftIcon: !isSmallScreen || forceIcon
            ? leftIconName && renderIcon(leftIconName)
            : undefined, rightIcon: !isSmallScreen || forceIcon
            ? rightIconName && renderIcon(rightIconName)
            : undefined, onPress: onPress, isDisabled: isDisabled, variant: variant, bgColor: transparent ? "transparent" : undefined, size: size, 
        // For some reason the Button component from native-base
        // only accepts MutableRefObject, not ForwardedRef.
        ref: ref }, rest, { children: children })));
});
Button.displayName = "Button";
export default Button;
